<template lang="html">
  <div class="f-editor">
    <div class="f-inputs" :class="{disabled: !formula.editing}">
    <input class="f-name" type="text" v-model="formula.name" placeholder="formula name" :disabled="!formula.editing" v-on:input="$emit('input', $event.target.value)"/>
    <span class="equal">=</span>
    <input class="f-equation" type="text" v-model="formula.equation" placeholder="_subscription_/_install_*100" ref="equation" :disabled="!formula.editing"/>
    </div>
    <div class="f-events" v-if="formula.editing">
      <div class="f-event" v-for="(event,id) in eventsToDisplay" :key="id" @click="insertAtCaret(event)">
        {{event}}
      </div>
    </div>
  </div>

</template>

<script>
import store from "@/store/store.js"
export default {
  props: {
    formula: {
      type: Object,
      required: true
    },
  },
  computed: {
    events() {
      return store.state.events
    },
    eventsToDisplay: function() {
      var eventsToDisplay = []
      for (var i = 0; i < this.events.length; i++) {
        if (this.events[i].isPresent) {
          eventsToDisplay.push(this.events[i].name)
        }
      }
      return eventsToDisplay
    }
  },
  methods: {
    insertAtCaret(event) {
      var el = this.$refs.equation;
      var caretPos = el.selectionStart;
      var txtToAdd = '_' + event + '_';
      this.formula.equation = this.formula.equation.substring(0, caretPos) + txtToAdd + this.formula.equation.substring(caretPos);
      el.focus();
      setTimeout(() => {
        el.selectionStart = caretPos + txtToAdd.length
        el.selectionEnd = el.selectionStart
      }, 1);
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/variables.scss';
.f-editor {
    .f-inputs {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid $blue;
        &.disabled {
            // background-color: $lightGray;
        }
        input {
            position: relative;
            display: inline-block;
            min-height: 25px;
            line-height: 20px;
            background: #fff;
            padding: 0 0 0 5px;
            width: 100%;
            box-sizing: border-box;
            vertical-align: top;
            border: none;
            background-color: inherit;
        }
        .equal {
            align-items: center;
            display: inline-flex;
            margin-left: 5px;
            margin-right: 5px;
        }
        .f-name {
            width: 100px;
        }
        .f-equation {
            width: 400px;
        }
    }
    .f-events {
        margin-top: 5px;
        display: flex;
        .f-event {
            padding: 2px 6px;
            border-radius: 8px;
            border: 2px solid $blue;
            margin-right: 10px;
            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>
